
import { defineComponent, computed, PropType, ref } from 'vue';
import { ElMessageBox, ElForm, ElMessage } from 'element-plus';
import {
  ISecondMenuItem,
  serviceBasicInfoRes,
  ISecondMenuOptions,
  ISecondCallBackItem,
  ISecondMenuList,
  ISecondLevelMenuByLikeReq,
} from '@/api/project-service/type.d';
import { HANDLE_SERVICE_TYPE_LIST, FIRST_PEOPLE_ENUM } from '@/constant/project-service/index';
import {
  manageQuerySecondLevelMenuByLike,
  manageSelectAllServiceBasicInfo,
} from '@/api/project-service/index';
import { UserItem } from '@/api/auth-manage/user/type.d';
import { useFuzzy } from '@/hooks/use-fuzzy';
import { fuzzyQueryUser } from '@/api/auth-manage/user/index';

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    menuOptions: {
      type: Object as PropType<ISecondMenuOptions>,
      default: () => {
        return {};
      },
    },
  },
  emits: ['update:modelValue', 'onSuccess'],
  setup(props, { emit }) {
    const id = ref<number>(0);
    const selected = ref<any[]>([]);
    const secondMenuList = ref<ISecondMenuList[]>([]);
    const secondRuleFormRefList = ref<typeof ElForm[]>([]);
    const submitMenuList = ref<ISecondCallBackItem>({
      projectName: '',
      firstLevelMenu: '',
      secondList: [],
    });
    const servicesList = ref<serviceBasicInfoRes>({} as serviceBasicInfoRes);
    const secondMenuOptions = ref<string[]>([]);
    const secondLevelMenuByLikeReq = ref<ISecondLevelMenuByLikeReq>(
      {} as ISecondLevelMenuByLikeReq,
    );
    const handleAdd = () => {
      id.value += 1;
      return {
        id: id.value,
        isShowTip: false,
        secondList: {} as ISecondMenuItem,
      };
    };

    const handleShowInit = () => {
      const {
      // id,
        serviceType,
        serviceName,
        headOfDevelopment,
        secondHeadOfDevelopment,
        headOfTest,
        secondHeadOfTest,
        firstHeadBackend,
        secondHeadBackend,
      } = props.menuOptions;
      secondMenuList.value.forEach((e) => {
        e.secondList.serviceType = e.secondList.serviceType
          ? e.secondList.serviceType
          : serviceType;
        e.secondList.serviceName = e.secondList.serviceName
          ? e.secondList.serviceName
          : serviceName;
        e.secondList.firstHeadBackend = e.secondList.firstHeadBackend
          ? e.secondList.firstHeadBackend
          : firstHeadBackend;
        e.secondList.secondHeadBackend = e.secondList.secondHeadBackend
          ? e.secondList.secondHeadBackend
          : secondHeadBackend;
        e.secondList.headOfDevelopment = e.secondList.headOfDevelopment
          ? e.secondList.headOfDevelopment
          : headOfDevelopment;
        e.secondList.secondHeadOfDevelopment = e.secondList.secondHeadOfDevelopment
          ? e.secondList.secondHeadOfDevelopment
          : secondHeadOfDevelopment;
        e.secondList.headOfTest = e.secondList.headOfTest
          ? e.secondList.headOfTest
          : headOfTest;
        e.secondList.headOfTest = e.secondList.headOfTest
          ? e.secondList.headOfTest
          : headOfTest;
        e.secondList.secondHeadOfTest = e.secondList.secondHeadOfTest
          ? e.secondList.secondHeadOfTest
          : secondHeadOfTest;
      });
    };
    // 模糊输入负责人名字
    const {
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    } = useFuzzy<any, UserItem[]>({
      params: { keyword: '' },
      keywordKey: 'keyword',
      API: fuzzyQueryUser,
      beforeRequest(_param, query) {
        return query;
      },
      beforeResponse(res) {
        return res.data?.map((user: UserItem) => {
          const { name: label, userId: value } = user;
          return { ...user, label, value };
        });
      },
    });
    const handleSelectRemoteItem = (userInfo: UserItem, row:ISecondMenuItem, key: FIRST_PEOPLE_ENUM) => {
      switch (key) {
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_FIRST:
          row.headOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.headOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.DEVELOPMENT_SECOND:
          row.secondHeadOfDevelopment = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.secondHeadOfDevelopment = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_FIRST:
          row.headOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.headOfTest = '';
          }
          break;
        case FIRST_PEOPLE_ENUM.TEST_SECOND:
          row.secondHeadOfTest = `${userInfo.name}(${userInfo.bbCode})`;
          if (userInfo.name === undefined || userInfo.bbCode === undefined) {
            row.secondHeadOfTest = '';
          }
          break;
        default: break;
      }
    };
    const handleCallBackShow = () => {
      if (!props.menuOptions.secondLevelMenuInfos?.length) {
        const add = handleAdd();
        secondMenuList.value.push(add);
        handleShowInit();
      } else {
          props.menuOptions.secondLevelMenuInfos?.forEach((ite) => {
            const add = handleAdd();
            add.secondList = ite;
            secondMenuList.value.push(add);
          });
      }
    };
    const visible = computed({
      get() {
        return props.modelValue;
      },
      set(val: boolean) {
        if (!val) {
          secondMenuList.value = [];
        }
        emit('update:modelValue', val);
      },
    });
    const handleSubmit = async () => {
      const checkPass = ref<number>(0);
      // 校验
      secondRuleFormRefList.value.forEach(async (item) => {
        await item?.validate((vialed: boolean) => {
          if (vialed) {
            checkPass.value += 1;
          }
        });
      });
      if (checkPass.value > 0
      && checkPass.value === secondRuleFormRefList.value.length) {
        const menuList = secondMenuList.value.map((item) => {
          const { secondLevelMenu } = item.secondList;
          return secondLevelMenu;
        });
        if ([...new Set(menuList)].length !== menuList.length) {
          ElMessage.error('二级菜单新增存在重复，请检查!');
          return;
        }
        ElMessageBox.confirm(
          '是否确定?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            submitMenuList.value = {} as ISecondCallBackItem;
            submitMenuList.value.secondList = [];
            secondMenuList.value.forEach((item) => {
              submitMenuList.value.projectName = props.menuOptions.projectName;
              submitMenuList.value.firstLevelMenu = props.menuOptions.firstLevelMenu;
            submitMenuList.value.secondList?.push(item.secondList);
            });
            emit('onSuccess', submitMenuList.value);
            emit('update:modelValue', false);
            ElMessage.success('保存成功');
          })
          .catch((error: string) => {
            console.log(error);
            ElMessage.warning('取消保存');
          });
      }
    };
    const handleSelectionChange = (val: any[]) => {
      selected.value = val;
    };
    const handleAddSecondMenu = () => {
      const add = handleAdd();
      secondMenuList.value.push(add);
      handleShowInit();
    };
    const handleCancel = () => {
      submitMenuList.value.secondList = [];
      submitMenuList.value = {} as ISecondCallBackItem;
      emit('update:modelValue');
    };
    const handleDeleteFirstMenu = () => {
      if (selected.value.length) {
        if (selected.value.length === secondMenuList.value.length) {
          secondMenuList.value = [];
          return;
        }
        selected.value.forEach((item) => {
          const index = secondMenuList.value.indexOf(item);
          secondMenuList.value.splice(index, 1);
        });
        selected.value = [];
      }
    };
    const handleSelectServiceItem = (val: any, row: ISecondMenuItem) => {
      const res = servicesList.value.filter((item) => {
        return item.serviceName === val;
      });
      if (res[0]?.firstHeadOfBackend === '') {
        row.firstHeadBackend = '';
      }
      if (res[0]?.secondHeadOfBackend === '') {
        row.secondHeadBackend = '';
      }
      row.firstHeadBackend = `${res[0]?.firstHeadOfBackend}(${res[0]?.firstHeadOfBackendCode})`;
      row.secondHeadBackend = `${res[0]?.secondHeadOfBackend}(${res[0]?.secondHeadOfBackendCode})`;
      if (res[0]?.firstHeadOfBackend === '') {
        row.firstHeadBackend = '';
      }
      if (res[0]?.secondHeadOfBackend === '') {
        row.secondHeadBackend = '';
      }
    };
    const handleSearchSecondMenuList = async (query: string) => {
      if (!query) {
        secondMenuOptions.value = [];
        return;
      }
      secondLevelMenuByLikeReq.value.projectName = props.menuOptions.projectName;
      secondLevelMenuByLikeReq.value.firstLevelMenu = props.menuOptions.firstLevelMenu;
      secondLevelMenuByLikeReq.value.keyword = query;
      const { data } = await manageQuerySecondLevelMenuByLike(
        secondLevelMenuByLikeReq.value,
      );
      if (!data) {
        secondMenuOptions.value = [];
        return;
      }
      secondMenuOptions.value = data;
    };
    const handleSearchService = async () => {
      const { data } = await manageSelectAllServiceBasicInfo();
      if (!data) {
        servicesList.value = [];
        return;
      }
      servicesList.value = data;
    };
    // 处理展开行输入自动收起
    const handleRowKey = (row: any) => {
      return row.id;
    };
    // 自定义校验
    const handleCustomerCheck = (rule: any, value: any, callback: any) => {
      if (secondMenuOptions.value.includes(value)) {
        callback(new Error(`二级菜单【${value}】已存在`));
      }
      callback();
    };
    // 格式校验
    const secondRules = ref({
      secondLevelMenu: [
        { required: true, message: '请输入二级菜单或删除', trigger: 'change' },
        { required: true, validator: handleCustomerCheck, trigger: 'change' },
      ],
    });
    const handleShowTip = (key: string, row: any) => {
      if (key === '') {
        row.isShowTip = false;
        return;
      }
      if (!secondMenuOptions.value.includes(key)) {
        row.isShowTip = true;
      } else {
        row.isShowTip = false;
      }
    };
    return {
      visible,
      secondMenuList,
      secondMenuOptions,
      secondRuleFormRefList,
      handleRowKey,
      selected,
      secondRules,
      handleCallBackShow,
      handleShowTip,
      servicesList,
      handleCancel,
      handleSubmit,
      secondLevelMenuByLikeReq,
      handleSearchService,
      handleSearchSecondMenuList,
      handleSelectionChange,
      handleSelectServiceItem,
      handleAddSecondMenu,
      handleDeleteFirstMenu,
      HANDLE_SERVICE_TYPE_LIST,
      FIRST_PEOPLE_ENUM,
      handleSelectRemoteItem,
      fuzzyLoading,
      fuzzyResponse,
      fuzzyRemoteMethod,
    };
  },
});
